import React from 'react';
import { X } from 'lucide-react';
import { useUI } from '../../contexts/UIContext';

const Modal = () => {
  const { modalContent, hideModal } = useUI();
  const { title, message } = modalContent;

  return (
    <div className="modal-overlay" onClick={hideModal}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{title}</h2>
          <span className="close-modal" onClick={hideModal}>
            <X size={24} />
          </span>
        </div>
        <div className="modal-body">
          <p>{message}</p>
        </div>
        <div className="modal-footer">
          <button className="modal-btn" onClick={hideModal}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
